/* eslint-disable eol-last */
import { loaderService } from '../../components/loader/loader.service';
import { alertService } from '../../components/toaster/alert.service';
import AxiosInstance from '../../interceptor/http-intercepor';
import Configuration from '../../utils/config';

class RFPDashboardService {
  constructor() {
    this.config = new Configuration();
  }

  async addRFP(rfpObj) {
    loaderService.show(true);
    const self = this;
    const userId = localStorage.getItem('userId');
    rfpObj.companyInformation = rfpObj.stepsValue.companyInformation;
    rfpObj.projectInformation = rfpObj.stepsValue.projectInformation;
    rfpObj.technicalRequirements = rfpObj.stepsValue.technicalRequirements;
    rfpObj.commercialEvaluation = rfpObj.stepsValue.commercialEvaluation;
    rfpObj.vendorInvite = rfpObj.stepsValue.vendorInvite;
    rfpObj.nda = rfpObj.stepsValue.nda;
    rfpObj.vendorShortList = rfpObj.stepsValue.vendorShortList;
    rfpObj.proofOfconceptValue = rfpObj.stepsValue.proofOfconceptValue;
    rfpObj.statementOfWork = rfpObj.stepsValue.proofOfconceptValue;
    rfpObj.finalPresentation = rfpObj.stepsValue.proofOfconceptValue;
    rfpObj.references = rfpObj.stepsValue.proofOfconceptValue;
    rfpObj.pricingNegotiations = rfpObj.stepsValue.proofOfconceptValue;
    rfpObj.contactAgreements = rfpObj.stepsValue.proofOfconceptValue;
    rfpObj.rfpCompletion = rfpObj.stepsValue.proofOfconceptValue;
    rfpObj.userId = userId;
    const url = this.config.addRfp;
    return AxiosInstance.post(url, rfpObj)
      .then((response) => {
        loaderService.show(false);
        if (response.status !== 200) {
          this.handleResponseError(response);
        }
        return response.data;
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        self.handleError(error);
      });
  }

  async updateRfpCategory(rfpObj) {
    loaderService.show(true);
    const self = this;
    const userId = localStorage.getItem('userId');
    rfpObj.userId = userId;
    const url = this.config.updateRfpCategories;
    return AxiosInstance.post(url, rfpObj)
      .then((response) => {
        loaderService.show(false);
        if (response.status !== 200) {
          this.handleResponseError(response);
        }
        return response.data;
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        self.handleError(error);
      });
  }

  async getrfpByIdName(rfpId) {
    const self = this;
    loaderService.show(true);
    const userId = localStorage.getItem('userId');
    const url = this.config.getRfpbyId + rfpId;

    return AxiosInstance.get(url)
      .then((response) => {
        loaderService.show(false);
        if (response.status !== 200) {
          this.handleResponseError(response);
        }
        return response.data;
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        self.handleError(error);
      });
  }

  async getrfpById(rfpId) {
    const self = this;
    loaderService.show(true);
    const userId = localStorage.getItem('userId');
    const url = this.config.getRFPDashboardById + rfpId + '/' + userId;
    return AxiosInstance.get(url)
      .then((response) => {
        loaderService.show(false);
        if (response.status !== 200) {
          this.handleResponseError(response);
        }
        return response.data;
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        self.handleError(error);
      });
  }

  async getrfpDashboardDetails(rfpId) {
    const self = this;
    loaderService.show(true);
    const userId = localStorage.getItem('userId');
    const url = this.config.getRFPDashboardDetail + rfpId;
    return AxiosInstance.get(url)
      .then((response) => {
        loaderService.show(false);
        //if (response.status !== 200) {
        //  this.handleResponseError(response);
        //}
        return response.data;
      })
      .then((res) => {
        return res.data;
      })
      .catch((error) => {
        self.handleError(error);
      });
  }

  async getVendorResponse(rfpId) {
    const self = this;
    loaderService.show(true);
    const userId = localStorage.getItem('userId');
    const url = this.config.getRFPVendorResponse + rfpId;
    return AxiosInstance.get(url)
      .then((response) => {
        loaderService.show(false);
        if (response.status !== 200) {
          this.handleResponseError(response);
        }
        return response.data;
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        self.handleError(error);
      });
  }

  async getrfpTimelines(rfpId) {
    const self = this;
    loaderService.show(true);
    const userId = localStorage.getItem('userId');
    const url = this.config.getRFPTimeline + rfpId;
    return AxiosInstance.get(url)
      .then((response) => {
        loaderService.show(false);
        if (response.status !== 200) {
          this.handleResponseError(response);
        }
        return response.data;
      })
      .then((res) => {
        return res;
      })
      .catch((error) => {
        self.handleError(error);
      });
  }

  handleResponseError(response) {
    loaderService.show(false);
    throw new Error(`HTTP error, status = ${response.status}`);
  }

  handleError(error) {
    loaderService.show(false);
    if (error.response) {
      const autoClose = true;
      const keepAfterRouteChange = false
      alertService.error(error.response.data.message, { autoClose, keepAfterRouteChange })
      //alertService.error('Error hhh', { id: 'left-alert' });
      // Request made and server responded
      console.log(':: error', error.response.data);
      // alert(error.response.data.message);
      console.log(':: error', error.response.status);
      console.log(':: error', error.response.headers);
    } else if (error.request) {
      // The request was made but no response was received
      console.log(':: error', error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log(':: Error', error.message);
    }
  }
}

export default RFPDashboardService;
